import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useSession } from "~/app/providers/SessionProvider";
import { RequestConfigurationQuoteDialog } from "~/domains/configurator/components/dialogs";
import { sendLinearRequestQuote } from "~/features/configurator/Linear/api/sendLinearRequestQuote";
import { getCurrentStep, getProductCode } from "~/features/configurator/Linear/redux/selectors";
import { useLinearProductInfo } from "~/features/configurator/Linear/redux/useLinearProductInfo";

interface Props {
  onClose: () => void;
}

const LinearRequestQuotePopup = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const requestQuoteEmail = useSession()?.commerceContext?.linearConfiguratorEmail ?? "";
  const productInfo = useLinearProductInfo();
  const productCode = useSelector(getProductCode);
  const currentStep = useSelector(getCurrentStep);

  return (
    <RequestConfigurationQuoteDialog
      open
      title={t("linearConfigSummary.card.addToQuote")}
      body={t("linear.request.quote.popup.body")}
      recipientLabel={t("linear.request.quote.popup.email.label")}
      recipient={requestQuoteEmail}
      noteLabel={t("linear.request.quote.popup.input.label")}
      info={t("linear.request.quote.popup.email.info")}
      mandatoryText={t("linear.request.quote.popup.mandatory")}
      cancelLabel={t("cancel")}
      submitLabel={t("linearConfigSummary.card.addToQuote")}
      submitError={t("hybrisAjaxError")}
      onClose={onClose}
      onSubmit={async (recipientNote) => {
        await sendLinearRequestQuote(
          productCode,
          productInfo.configId,
          recipientNote,
          currentStep + 1,
          productInfo.designation,
        );
      }}
    />
  );
};

export default LinearRequestQuotePopup;
